module.exports = __webpack_public_path__ + "img/148ne.b1b9f472.svg";